import { api } from '@/services/apiService'

import type { Config } from '@/services/apiService'
import type { DashboardState } from '@/store/types'
import type { DietDisplayType } from '@/types/Diet'

export type AddPatient = {
  birth_date: string
  email?: string
  gender: number
  name: string
  pattern_name: string
}

export const dashboardService = {
  addDiet: async (
    data: { group: number | null; name: string; dietDisplayType: DietDisplayType },
    config?: Config,
  ) => {
    return api.post<{ id: string }>(
      '/diets/user/',
      {
        data: { diet_type: data.dietDisplayType, name: data.name },
        group: data.group,
        name: data.name,
      },
      config,
    )
  },
  addPatient: (data: AddPatient, config?: Config) => {
    return api.post<{ patient_tab_available: boolean; url: string }>('/dietitian/', data, config)
  },
  fetchPatientsOptions: () => {
    return api.options('/dietitian/')
  },
  fetchStats: () => {
    return api.get<DashboardState['userDashboard']>('/dashboard/')
  },
}
